import { Action, ActionResponse } from '../../../../../shared/xs/actions';
import { BillingAddress } from '../../../../../auth';
import { UserToInviteModel } from '../../../../../company-profile/invite/user-to-invite.model';

export interface UpdateCompanyActionPayload {
  draft: boolean;
  name: string;
  country: string;
  registeredId: string;
  contactEmail: string;
  localSectorCode?: string;
  redirect?: boolean;
  usersToInvite?: UserToInviteModel[];
  loadedFromBackend?: boolean;
}

export class UpdateCompanyAction implements Action {
  static readonly type = '[Dashboard] Update Company';

  constructor(public payload: UpdateCompanyActionPayload) {}
}

export interface UpdateCompanyActionResponse extends ActionResponse {
  country: string;
  registeredId: string;
  name: string;
  legalEntityType: string;
  numberOfEmployees: number;
  annualTurnover: number;
  totalAssets: number;
  localSectorCode: string;
  billingAddress?: BillingAddress;
}
